<template>
  <div class="vx-row">
      <vx-card title="USER LIST" v-can:any="['create-user', 'view-user']">
        <template slot="actions">
            <vs-button v-can="'create-user'" @click="onClickCreateUser" class="mr-4" color="primary" type="filled">Create User</vs-button>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                    v-model="filters['search']"

                    class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
          <vs-table v-can="'view-user'" :max-items="(meta.per_page) ? meta.per_page : 10" id="users-list"
                    :data="users_list"  @sort="handleSort"  :sst="true" stripe
                    class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th >Full Name</vs-th>
              <vs-th >Email</vs-th>
              <vs-th >User Role</vs-th>
              <vs-th >Created At</vs-th>
              <vs-th width="10%">Action</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr  :key="indextr" v-for="(tr, indextr) in data">


                <vs-td :data="data[indextr].fullName">
                  {{ data[indextr].fullName }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].profile.name }}
                </vs-td>

                <vs-td :data="data[indextr].createdAt">
                  {{__dateTimeFormatter(data[indextr].createdAt)}}
                </vs-td>

               
                <vs-td v-can="'update-user'">
                  <div class="vx-row">
                    <vx-tooltip class="mr-2" text="Edit" position="top">
                      <vs-button @click.stop="onClickUserEdit(data[indextr]._id)"
                                 size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="Reset Password" position="top">
                      <vs-button @click.stop="onClickResetPassword(data[indextr])"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-refresh-ccw"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>


          </vs-table>
          <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

        </div>
      </vx-card>
    <update-staff-pop-up ref="updateStaffPopup"/>
    <create-staff-pop-up ref="createStaffPopup"/>
    <reset-user-password-pop-up ref="resetUserPasswordPopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import UpdateStaffPopUp from '@/components/popups/staff/UpdateStaffPopUp'
import CreateStaffPopUp from '@/components/popups/staff/CreateStaffPopUp'
import ResetUserPasswordPopUp from '@/components/popups/staff/ResetUserPasswordPopUp'

const UserRepository = RepositoryFactory.get('user')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: 'AllUsersList',
  data () {
    return {
      users_list: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
    }
  },
  components: {
    UpdateStaffPopUp,
    CreateStaffPopUp,
    ResetUserPasswordPopUp
  },
  methods: {
    async refreshData () {
      await this.fetchUsersList()
    },
    async onClickUserEdit (id) {
      await this.$refs.updateStaffPopup.openPopup(id)
    },
    async onClickResetPassword(user) {
      await this.$refs.resetUserPasswordPopUp.openPopup(user)
    },
    async onClickResendWelcomeEmail(email) {
      this.$vs.loading()
      try {
        await UserRepository.resendWelcomeEmail(email)
        this.showSuccessMessage('Email resent successfully')
      }catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchUsersList() {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = (await UserRepository.get(this.page, this.filterQuery, 10, this.sort)).data
        this.users_list =  data.data
        this.meta = data.pagination
        this.meta.last_page = Math.ceil(this.meta.totalRecords / this.meta.pageSize)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },

    async onClickCreateUser () {
      await this.$refs.createStaffPopup.openPopup()
    },

    filterQueryUpdate (){
      this.fetchUsersList()
    },

    handleChangePage(page) {
      this.page=page;
      this.fetchUsersList()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchUsersList()
      }

    }

  },
  watch : {
    page(){
      this.fetchUsersList()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>

</style>
